import React from "react";
import { HOME } from "@/constants/testIds";
import { ShipmentDashboard } from "./ShipmentDashboard";

export const Hero = () => {
  return (
    <section id="top" className="relative pt-14 pb-24 md:pt-20 md:pb-32 overflow-hidden">
      {/* Background grid + blue glow */}
      <div className="absolute inset-0 grid-bg opacity-60 pointer-events-none" />
      <div className="absolute -top-40 right-[-10%] h-[520px] w-[520px] rounded-full bg-[radial-gradient(closest-side,hsla(217,85%,48%,0.18),transparent)] pointer-events-none" />
      <div className="absolute -bottom-40 left-[-10%] h-[480px] w-[480px] rounded-full bg-[radial-gradient(closest-side,hsla(222,47%,7%,0.06),transparent)] pointer-events-none" />

      <div className="container-narrow relative">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          {/* Left — Copy */}
          <div className="lg:col-span-5">
            <div
              data-testid={HOME.heroEyebrow}
              className="inline-flex items-center gap-2 rounded-full border border-ink-15 bg-white/70 px-3 py-1.5 text-[11px] font-mono uppercase tracking-[0.18em] ink-soft"
            >
              <span className="relative grid place-items-center">
                <span className="h-1.5 w-1.5 rounded-full bg-emerald dot-pulse" />
              </span>
              Workspace Product
            </div>

            <h1
              data-testid={HOME.heroHeadline}
              className="mt-6 font-display text-4xl sm:text-5xl lg:text-[64px] leading-[1.02] font-semibold ink text-balance"
            >
              Live Shipment <br className="hidden sm:block" />
              Tracking
              <span className="text-emerald align-top text-3xl lg:text-4xl ml-1">™</span>
            </h1>

            <p
              data-testid={HOME.heroSubheadline}
              className="mt-5 text-xl lg:text-2xl font-display font-medium ink-soft leading-snug text-balance"
            >
              Know where every shipment is.
              <br />
              <span className="ink">Every minute. Every milestone.</span>
            </p>

            <p
              data-testid={HOME.heroDescription}
              className="mt-5 text-[15px] ink-soft leading-relaxed max-w-lg text-pretty"
            >
              Track every shipment in real time — from container loading to final
              delivery — while staying connected to documents, milestones and
              import operations inside one Workspace.
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-3">
              <a
                href="#start"
                data-testid={HOME.heroCtaPrimary}
                className="inline-flex items-center gap-2 bg-ink text-[hsl(var(--ivory))] px-5 py-3 rounded-xl text-[14px] font-medium hover:bg-[hsla(222,47%,12%,1)] transition-all hover:translate-y-[-1px] shadow-[0_8px_24px_-12px_hsla(222,47%,7%,0.4)]"
              >
                Start Tracking
                <span aria-hidden>→</span>
              </a>
              <a
                href="#workspace"
                data-testid={HOME.heroCtaSecondary}
                className="inline-flex items-center gap-2 bg-white/70 border border-ink-15 ink px-5 py-3 rounded-xl text-[14px] font-medium hover:bg-white transition-colors"
              >
                Create your free Workspace
              </a>
            </div>
          </div>

          {/* Right — Dashboard */}
          <div className="lg:col-span-7">
            <ShipmentDashboard />
          </div>
        </div>
      </div>
    </section>
  );
};
